/*
 *
 * MailConfiguration constants
 *
 */

export const GET_CONFIGURATION_WATCHER =
  "app/MailConfiguration/GET_CONFIGURATION_WATCHER"
export const GET_CONFIGURATION_SUCCESS =
  "app/MailConfiguration/GET_CONFIGURATION_SUCCESS"
export const GET_CONFIGURATION_FAILED =
  "app/MailConfiguration/GET_CONFIGURATION_FAILED"

export const GET_IMAGE_LOGO_WATCHER =
  "app/MailConfiguration/GET_IMAGE_LOGO_WATCHER"
export const GET_IMAGE_LOGO_SUCCESS =
  "app/MailConfiguration/GET_IMAGE_LOGO_SUCCESS"
export const GET_IMAGE_LOGO_FAILED =
  "app/MailConfiguration/GET_IMAGE_LOGO_FAILED"
